import { styled } from "styled-components";

export const P = styled.p`
    font-family: 'SF Pro Display';
    margin: ${props => props.noMargin === true ? 0 : '0.5rem 0'}
`

export const Pb = styled(P)`
    font-weight: bold;
`

export const H1 = styled(P)`
    font-size: 2rem;
    font-weight: bold;
`

export const Subheading = styled(Pb)`
    font-size: 0.9rem;
`